// Therapist registration

import { createApp } from 'vue/dist/vue.esm-bundler';
import TherapistRegistration from '@/components/doctor-therapist/registration-modal/TherapistRegistration.vue';

const therapistRegistrationModal = document.querySelector('#therapistRegistrationModalComponent');

if ( therapistRegistrationModal )
{
  createApp({
    components: {
      TherapistRegistration
    }
  }).mount('#therapistRegistrationModalComponent');
}